<template>
  <div class="zj-home">
    Home Page
  </div>
</template>

<script>
export default {
  name: 'ZjHome'
}
</script>
